import { createSelector } from 'reselect';

const selectdigitalPublicInfrastructures = (state: any) => state.digitalPublicInfrastructures;


export const selectdigitalPublicInfrastructuresCurrentItem = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.current);

export const selectdigitalPublicInfrastructuresListItems = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectdigitalPublicInfrastructuresListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectdigitalPublicInfrastructuresQueryItems = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.query);

export const selectdigitalPublicInfrastructuresCreatedItem = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.create);

export const selectdigitalPublicInfrastructuresUpdatedItem = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.update);

export const selectdigitalPublicInfrastructuresReadItem = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.read);

export const selectdigitalPublicInfrastructuresDeletedItem = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.delete);

export const selectdigitalPublicInfrastructuresSearchedItems = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.search);

export const selectdigitalPublicInfrastructuresItemsCount = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.count);

export const selectdigitalPublicInfrastructuresItemsFilter = createSelector([selectdigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.filter);